import { apiRequest, getResource } from "../api/http";

// Health of the platform and incidents ("logs" section).
const BASE = "/api/admin/incidents";

/** Health snapshot: { overall, components, api }; `force` checks the external services now. */
export const getHealth = (force = false) => getResource(`${BASE}/health${force ? "?force=true" : ""}`, { rethrow: true });
export const getIncidents = (status = "open") => getResource(`${BASE}?status=${status}`, { rethrow: true });
/** { title, severity, components, impact, note } → { incident }; rejects with the API message. */
export const createIncident = (body) => apiRequest("post", BASE, { data: body, rethrow: true });
/** { note, status, severity, components, impact, takeOwnership } → { incident }. */
export const updateIncident = (id, body) => apiRequest("post", `${BASE}/${id}/updates`, { data: body, rethrow: true });
/** { cause, fix, actions } → { incident }. */
export const savePostmortem = (id, body) => apiRequest("put", `${BASE}/${id}/postmortem`, { data: body, rethrow: true });
